import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import AOS from 'aos'
// import Lottie from '../utils/lottie';
// import developer from '../assets/homepage.json';

export default function Welcome({ title, description, button, video }) {
  useEffect(() => {
    AOS.init()
    AOS.refresh()
  }, [])
  return (
    <div className="home">
      <div
        data-aos="zoom-in-up"
        data-aos-delay="400"
        data-aos-duration="750"
        className="left"
      >
        <h1 style={{ fontSize: '2em' }}>
          {title ? title : <div>Step Up and Revive Your<br></br>DEVELOPER CAREER<br></br>With Skills, Confidence and Ease.</div> }
        </h1>
        <p>
          {description
            ? description
            : <div>
              <ul>
                <li><b>CREATE</b> internship grade super development projects and presentations.</li><br></br>
                <li><b>LEARN</b> the skills of the stack development or backend development with great comfort hands on.</li><br></br>
                <li><b>BOOST UP</b> your career with the real work experience in the real work space.</li>
              </ul>
           </div>}
        </p>
        <Link to="/product">
          <div className="slide-button">
            <button>
              {' '}
              {button ? button : 'Order Your Website Now'}{' '}
              <i class="fas fa-arrow-right"></i>{' '}
            </button>
          </div>
        </Link>
      </div>
      <div data-aos="zoom-in-up" className="right">
        <div className="ratio ratio-16x9">
          <iframe
            className="responsive-iframe"
            src={video ? video : 'https://www.youtube.com/embed/xcJtL7QggTI'}
            title="YouTube video"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  )
}
